import React from "react";
import CreateWorkflow from "./createWorkflowPopup/CreateWorkflow";
import { useResponsive } from "../../../../hooks/useResponsive";
import { Grid, Stack, Typography, useScrollTrigger } from "@mui/material";
import { CustomButton } from "../../../../components/Button/Button";
import { AddRoundedIcon } from "../../../../utils/constants/icons";
import { useWorkflowDialogState } from "../hooks/useWorkflowDialogState";

const HeaderWorkflow = () => {
  const isMobile = useResponsive("down", "md");
  const trigger = useScrollTrigger();
  const workflowDialog = useWorkflowDialogState();

  return (
    <>
      {workflowDialog.isOpen && (
        <CreateWorkflow
          open={workflowDialog.isOpen}
          close={workflowDialog.setOpen}
        />
      )}
      {isMobile ? (
        <Grid
          container
          xs={12}
          className="remove-container-width fixed-ui"
          sx={{ top: trigger ? "0px" : isMobile ? "51px" : "" }}
          justifyContent={"center"}
          boxShadow={" 0px 1px 7px rgba(0, 0, 0, 0.3)"}
          pb={"16px !important"}
          pt={trigger ? "24px !important" : "20px !important"}
          alignItems={"center"}
        >
          <Grid
            item
            xs={6}
            md={12}
            lg={3}
            className="d-flex align-items-center"
          >
            <Typography fontWeight={600}>Workflow</Typography>
          </Grid>
          <Grid item xs={6} md={7} lg={9}>
            <Stack direction="row" justifyContent="end">
              <CustomButton
                onClick={workflowDialog.openDialog}
                className="create-new-button create-new-workflow-button"
                variant="contained"
                startIcon={<AddRoundedIcon/>}
              >
                Create New
              </CustomButton>
            </Stack>{" "}
          </Grid>
        </Grid>
      ) : (
        <div className="header-name d-flex justify-content-space-between align-items-center">
          <p>Workflow</p>
          <CustomButton
            onClick={workflowDialog.openDialog}
            className="create-new-button create-new-workflow-button"
            variant="contained"
            startIcon={<AddRoundedIcon/>}
          >
            Create New
          </CustomButton>
        </div>
      )}
    </>
  );
};

export default React.memo(HeaderWorkflow);
